<div class='configuration-planning-tab-2-part'>
	This is configuration-planning tab 2
</div>